var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCleanLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 20,
    viewBox: "0 0 11 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.72 8.43C7.68 6.39 7.5 2.66 7.5 2H6V4H2V2H0C0 0.9 0.9 0 2 0H9V1C9 1.08 9.04 5.63 10.78 7.37L9.72 8.43ZM10 0V2H11V0H10ZM8 10C6 8 6 5 6 5H2V7C2 8 2 8 1 9C0 10 0 11 0 11V18C0 19.1 0.9 20 2 20H6C7.1 20 8 19.1 8 18V10Z",
    fill: "#CFA7A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCleanLogo);
export default __webpack_public_path__ + "static/media/clean-logo.b9a5c657b40f75486ef3c169f2829aee.svg";
export { ForwardRef as ReactComponent };